import { setNewsSuccess } from "ducks/newsDetails/actions";
import { getPrefixForApi } from "utils/helpers";
import ACTION_TYPES from "./actionTypes";

import type {
  InstrumentDetailsObj,
  StartLoadingAction,
  StopLoadingAction,
  SetInstrumentActionFunc,
  GetInstrumentDetailsSuccessAction,
  GetInstrumentDetailsFailedAction
} from "./types";

const startLoading = (): StartLoadingAction => ({
  type: ACTION_TYPES.START_LOADING
});

const stopLoading = (): StopLoadingAction => ({
  type: ACTION_TYPES.STOP_LOADING
});

export const setInstrumentSuccess = (
  instrument: string,
  widgetTypeId?: string,
  marketTypeId?: string,
  valueTypeId?: string,
  exchangeId?: string,
  row?: any,
  instrumentId?: string
) => ({
  type: ACTION_TYPES.SET_INSTRUMENT_SUCCESS,
  selectedInstrument: instrument,
  widgetTypeId,
  marketTypeId,
  valueTypeId,
  exchangeId,
  row,
  instrumentId
});

export const setInstrumentIntraday = (instrument: Object) => ({
  type: ACTION_TYPES.SET_INSTRUMENT_INTRADAY,
  selectedInstrumentIntraday: instrument
});

const getInstrumentDetailsSuccess = (
  data: InstrumentDetailsObj | null
): GetInstrumentDetailsSuccessAction => ({
  type: ACTION_TYPES.GET_INSTRUMENT_SUCCESS,
  instrumentDetails: data
});

const getInstrumentDetailsFailed = (
  errors: string
): GetInstrumentDetailsFailedAction => ({
  type: ACTION_TYPES.GET_INSTRUMENT_FAILED,
  errors
});

export const setInstrumentAlarm = (
  instrument: string,
  instrumentSelectedDescription: string
) => ({
  type: ACTION_TYPES.SET_INSTRUMENT_ALARM_SUCCESS,
  instrumentSelectedAlarm: instrument,
  instrumentSelectedDescription
});

export const completeChartLoad = (chartLoad: boolean) => ({
  type: ACTION_TYPES.SET_CHART_LOAD_COMPLETED,
  chartLoadCompleted: chartLoad
});

export const setInstrumentOperation = (
  instrument: ?Object,
  typeOperation: string
) => ({
  type: ACTION_TYPES.SET_INSTRUMENT_OPERATION_SUCCESS,
  instrumentSelectedOperation: instrument,
  instrumentSelectedOperationType: typeOperation
});

export const setInstrument: SetInstrumentActionFunc = (
  instrument: string,
  widgetTypeId: string,
  instrumentId?: string
) => async dispatch => {
  dispatch(startLoading());
  dispatch(getInstrumentDetailsSuccess(null));
  dispatch(getInstrumentDetailsFailed(""));
  if (!instrument) {
    dispatch(setInstrumentSuccess(""));
    dispatch(getInstrumentDetailsSuccess(null));
    dispatch(stopLoading());
  } else {
    dispatch(setNewsSuccess(0));
    let splitPrefix;
    const prefix = getPrefixForApi(widgetTypeId);

    if (instrumentId) {
      splitPrefix = instrumentId.split("/");
    } else {
      splitPrefix = prefix.split("/");
    }
    const prefixDetail = {
      marketTypeId: splitPrefix[0],
      valueTypeId: splitPrefix[1],
      exchangeId: splitPrefix[2]
    };

    let errorsFromService;
    let errorsFromDetailService;

    const detailObj = {
      variacion: 0,
      precioActual: 0,
      porcentaje: 0,
      volumenTotal: 0
    };

    dispatch(
      setInstrumentSuccess(
        instrument,
        widgetTypeId,
        prefixDetail.marketTypeId,
        prefixDetail.valueTypeId,
        prefixDetail.exchangeId,
        detailObj,
        instrumentId
      )
    );

    if (errorsFromService && errorsFromDetailService) {
      dispatch(getInstrumentDetailsFailed(errorsFromService));
    }

    dispatch(stopLoading());
  }
};

export const setAlarmsCompleted = (alarmsCompleted: Array<string>) => ({
  type: ACTION_TYPES.SET_ALARMS_COMPLETED,
  alarmsCompleted
});

export default setInstrument;
